import React from "react";
import { Col, Row } from "react-bootstrap";
import StepZilla from "react-stepzilla";
import ProductInfo from "./ProductInfo";
import PriceInfo from "./PriceInfo";
import $ from "jquery";
import { newSubscriptionAction, uploadImageAction,  updateSubscriptionAction } from '../../../actions/SubscriptionAction';
import { connect } from "react-redux";
import * as code from '../../../config/Constants';
import { toastMessage } from '../../Common/Common';
import { Link } from "react-router-dom";
import { Close, HelpOutline } from "@material-ui/icons";


class EditSubscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      product_name: "",
      product_description: "",
      statement_descriptor: "",
      transactionCounter: "",
      templateCounter: "",
      emailSentCounter: "",
      textSentCounter: "",
      uploadDocumentSize: "",
      formError: '',
      priceInformation: [],
      uploadedFileName: '',
    };
  }
  componentWillMount() {
    let data = this.props.history.location.subscriptionData;
    let priceInfo =[];
    let newPrice = data.price !== undefined ? data.price : ''
    priceInfo.push(newPrice);
    this.state = {
      product_name: !!data.name ? data.name : '',
      product_description: !!data.description ? data.description : '',
      statement_descriptor: !!data.statementDescriptor ? data.statementDescriptor : '',
      transactionCounter: !!data.subscriptionLimit ? data.subscriptionLimit.transactionCounter : '',
      textSentCounter: !!data.subscriptionLimit ? data.subscriptionLimit.textSentCounter : '',
      templateCounter: !!data.subscriptionLimit ? data.subscriptionLimit.templateCounter : '',
      uploadDocumentSize: !!data.subscriptionLimit ? data.subscriptionLimit.uploadDocumentSize : '',
      emailSentCounter: !!data.subscriptionLimit ? data.subscriptionLimit.emailSentCounter : '',
      priceInformation: priceInfo,
    }
  }
  getSubscriptionData() {
    return this.state;
  }
  /**
 * @desc update subscription data with field name 
 * @param {*} field 
 * @param {*} value 
 */
  updateSubscriptionData(field, value) {
    var fieldState = {};
    fieldState[field] = value;
    this.setState(fieldState);
  }
  /**
* @desc get step number and performed actions
* @param {*} step 
*/
  getLastStep(step) {
    if (step === 0) {
      $(".saveBtn").html("Next");
    }
    if (step === 1) {
      $(".saveBtn").html("Update");
    }
    if (step === 2) {
      this.submitAction();
    }
  }
  submitAction() {
    this.setState({
      showLoader: true,
    });
    var data = this.props.history.location.subscriptionData;
    data.name = this.state.product_name;
    data.description = this.state.product_description;
    data.statementDescriptor = this.state.statement_descriptor;
    data.metaData = {
      transactionCounter: this.state.transactionCounter,
      templateCounter: this.state.templateCounter,
      emailSentCounter: this.state.emailSentCounter,
      textSentCounter: this.state.textSentCounter,
      uploadDocumentSize: this.state.uploadDocumentSize
    };
    data.price = this.state.priceInformation;
    this.editSubscription(data);

  }

  editSubscription(data) {
    this.props.updateSubscriptionAction(data).then(res => {
      this.props.history.push("/subscription");

      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, "Subscription updated");
        this.setState({ showLoader: false });
      } else {
        toastMessage(code.ERROR, res.data);
        this.setState({ showLoader: false });
      }
    })
  }
  render() {
    const steps = [
      {
        name: "Product Information",
        component: (
          <ProductInfo
            updateSubscriptionData={(k, v) => {
              this.updateSubscriptionData(k, v);
            }}
            editMode={this.props.history.location.editMode}
            getSubscriptionData={() => this.getSubscriptionData()}
          />
        )
      },
      {
        name: "Price Information",
        component: (
          <PriceInfo
            updateSubscriptionData={(k, v) => {
              this.updateSubscriptionData(k, v);
            }}
            editMode={this.props.history.location.editMode}
            getSubscriptionData={() => this.getSubscriptionData()}
          />
        )
      }
    ];

    if (this.state.showLoader) {
      return (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="step-progress transaction-create">
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
            <Col xs={12} sm={3}>
              <h4 className="title-med mt-0 pt-1">Edit Subscription</h4>
            </Col>

            <Col xs={12} sm={6}></Col>
            <Col xs={12} sm={3} align="right" className="transaction-close">
              <Link to="/subscription" className="nav-link p-0 color-black">
                <Close
                  style={{ stroke: "#fff", height: "40px", width: "40px" }}
                />
              </Link>
            </Col>
          </Row>
          <div className="multi-step multi-step-admin">
            <StepZilla
              showNavigation={true}
              steps={steps}
              backButtonCls="btn btn-sm btn-primary btn-blue btn-outlined w-140 mr-3"
              nextButtonCls={"btn btn-sm btn-primary btn-blue w-140 saveBtn"}
              backButtonText="Back"
              onStepChange={step => this.getLastStep(step)}
              hocValidationAppliedTo={[0]}
              preventEnterSubmission={true}
            />
          </div>


        </div>

      );
    }
  }
}
const mapStateToProps = state => {
  return {
    subscriptionData: state.reducer.subscriptionData,
    isImageDeleted: state.reducer.isImageDeleted,

  };
};

export default connect(mapStateToProps, { newSubscriptionAction, uploadImageAction,  updateSubscriptionAction })(EditSubscription)